import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Group_Interface } from 'src/app/Interface/General_Group_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentTitleService {
  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<General_Group_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DocumentTitle").pipe(
      map(data=>{
        return data as Array<General_Group_Interface>
      })
    )
  }

  GetActiveList(id:number):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DocumentTitle/GetActiveList?id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<General_Group_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/DocumentTitle/GetSingle?id="+id).pipe(
      map(data=>{
        return data as General_Group_Interface
      })
    )
  }

  AddDocumentTitle(model: General_Group_Interface):Observable<General_Group_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      group_id:model.group_id,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/DocumentTitle/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Group_Interface
        })
      )

  }

  EditDocumentTitle(model: General_Group_Interface):Observable<General_Group_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      group_id:model.group_id,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/DocumentTitle/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Group_Interface
        })
      )

  }

  DeleteDocumentTitle(id:number):Observable<General_Group_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/DocumentTitle/Delete?id="+id).pipe(
        map(data=>{
          return data as General_Group_Interface
        })
      )

  }

  }

